<template>
  <div>
    <div class="back">
      <div class="body">
        <div style="color:#000000;font-size:16px;height:40px">
          <el-button type="primary" size="small" @click="refreshData" style="margin-left: 15px;position: absolute;right:50px;width: 100px">
            <i class="el-icon-refresh-right el-icon--left"></i>{{$t('refresh')}}
          </el-button>
<!--          <el-select type="primary" size="small" style="margin-left: 15px;position:absolute;right:200px;;width: 200px" v-model="cupTypeGroup" @change="handleChangeCupTypeGroup">-->
<!--            <el-option v-for="(item,index) in cupTypeGroupList" :key="index" :label="item" :value="item"></el-option>-->
<!--          </el-select>-->
        </div>
        <div class="headback">
          <div class="c1" v-for="(item,index) in [0,1,2,3]"  :key="index" @click="changepowder(index)">
            <img  v-if="selectedpowder.length>index && selectedpowder[index]&&selectedpowder[index].picture"  :src="$prefix+selectedpowder[index].picture.path">
            <i class="el-icon-close" v-if="selectedpowder[index]"  @click.stop="deletePowder(index)" style="color:#ffffff;position: absolute;z-index:99999999"></i>
            <img  v-if="!selectedpowder[index]"  src="@/assets/images/nopic.png">
            <div v-if="selectedpowder.length>index&&selectedpowder[index]"><div class="cname">{{selectedpowder[index].name}}</div></div>
            <div v-if="!selectedpowder[index]"><div class="cname">{{$t('equipmentmanagement.pleaseSelect')}}</div></div>
          </div>
        </div>
        <div class="bodyback">
          <div class="c1" v-for="(item,index1) in drinks" :key="index1">
              <div v-for="(item2,index2) in item" :key="index2" style="height:160px">
                <div class="drinkback" :class="{noneback:!item2.cup,q1back:item2.cup&&item2.cupquantity==0,q2back:item2.cup&&item2.cupquantity==1,q3back:item2.cup&&item2.cupquantity==2}" @click="selectdrink(index1,index2)" >
                  <img v-if="item2.cup&&item2.cup.beverage&&item2.cup.beverage.picture" :src="$prefix + item2.cup.beverage.picture.path" @click="selectdrink(index1,index2)" class="dinkpic">
                  <img v-else-if="item2.cup!=null&&item2.cup.beverage&&item2.cup.beverage.picture==null" src="@/assets/images/nopic.png" @click="selectdrink(index1,index2)" class="nopic">
                  <i class="el-icon-close" v-if="item2.cup&&item2.cup.cupSize&&item2.cup.beverage"  @click.stop="deleteDrink(index1,index2)" style="position: absolute;z-index:99999999"></i>
                </div>
                <div  class="cname" v-if="item2.cup&&item2.cup.beverage">{{item2.cup.beverage.name}}</div>
                <div class="cname" v-if="item2.cup&&item2.cup.cupSize">{{item2.cup.cupSize.name}}</div>
                <!-- <el-input v-if="item2.cup&&item2.cup.cupSize" size="small" v-model="item2.price" class="cnameyuan" style="height:25px;width:70px"/>
                <span v-if="item2.cup&&item2.cup.cupSize">&nbsp;元</span> -->
              </div>
          </div>
          <div style="text-align: center">
            <div @click="saveBtnConfig" style="display: inline-block;cursor: pointer;line-height: 40px;background-color: #805451;color: #fff;border-radius: 20px;padding: 0 20px">{{$t('save')}}</div>
          </div>
        </div>

      </div>

    </div>

    <el-dialog
      width="50%"
      :title="$t('equipmentmanagement.powderCanister')"
      :visible.sync="allvisible"
      :close-on-click-modal="false"
      append-to-body
   >
      <div class="powderlist" v-if="allpowder.length>0">
        <div class="c2" v-for="(item,index) in allpowder" :key="index" @click="changeallpowder(index)">
          <img v-if="item.picture" :src="$prefix+item.picture.path">
          <div><div class="cname" v-if="item.name">{{item.name}}</div></div>
          <img v-if="item.id == powderid" class="checked" src="@/assets/images/equipment/select.png">
        </div>
      </div>
      <div class="powderlist" v-else>
        <el-empty :description="$t('equipmentmanagement.noIngredientForThisEquipment')"></el-empty>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allvisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="selectpowder()">{{$t('okSpace')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="50%"
      :title="$t('surong.cupType')"
      :visible.sync="cupvisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="powderlist" >
        <div v-for="(item,index) in allcuplist" :key="index">
          <div class="c2" v-if="selectedpowder[cupindex1] && item.beverage.rawMaterials[0]&&item.beverage.rawMaterials[0].id == selectedpowder[cupindex1].id && item.beverage"  @click="changecupe(index)">
            <img v-if="item.beverage&&item.beverage.picture" :src="$prefix+item.beverage.picture.path" height="100">
            <img v-else src="@/assets/images/nopic.png" class="nopic">
            <div><div class="cname" v-if="item.beverage&&item.cupSize">{{item.beverage.name+" "+item.cupSize.name}}</div></div>
            <img v-if="item.id == cupid" class="checked" src="@/assets/images/equipment/select.png">
          </div>
        </div>
      </div>
      <div>
        <div style="display: inline-block;line-height: 30px;vertical-align: top;margin-right: 20px;padding-left: 20px">{{$t('equipmentmanagement.powderVolumeIncreased')}}:</div>
        <div class="quantity q1" @click="changequantity(0)">{{$t('equipmentmanagement.normal')}}  <img v-if="cupquantity == 0" class="checked2" src="@/assets/images/equipment/select.png"></div>
        <div class="quantity q2" @click="changequantity(1)">{{$t('equipmentmanagement.muchStronger')}}  <img v-if="cupquantity == 1" class="checked2" src="@/assets/images/equipment/select.png"></div>
        <div class="quantity q3" @click="changequantity(2)">{{$t('equipmentmanagement.extraStrong')}}  <img v-if="cupquantity == 2" class="checked2" src="@/assets/images/equipment/select.png"> </div>
      </div>
      <div style="margin-top: 15px;">
        <div style="display: inline-block;line-height: 30px;vertical-align: top;margin-right: 20px;padding-left: 20px;width:90%">
          <span style="margin-right:10px">{{$t('equipmentmanagement.fineAdjustmentOfCupVolume')}}:</span>
          <el-input v-model="cupAmountFineAdjustment1" style="width:20%;margin-right:10px" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>%</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cupvisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="savepowder()">{{$t('okSpace')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props:
        ['initvalue']
    ,
    name:"EquipmentButtomConfig",
    data() {
      return {
        allvisible:false,
        isFree:true,
        allpowder:[],
        selectedpowder:[],
        powderindex:-1,
        powderid:-1,
        drinks:[
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}]
         ],
        allcuplist:[],
        cupvisible:false,
        postData: {
          keyConfigPostDatas:[],
          equipment_ID:0
        },
        cupid:-1,
        cupquantity: 1,
        cupindex1:-1,
        cupindex2:-1,
        BtnConfigList:[],
        price:'0.00',
        totalBtnConfigCount:0,
        cupAmountFineAdjustment1:100,
        cupTypeGroupList:[],// 杯型分组
        cupTypeGroup:'',//选中的杯型
        oriAllCupList:[],
        oriAllPowderList:[],
        isAllLoad:false,// 是否全部加载完成
        oldVal:''
      }
    },
    mounted() {
      Promise.all([this.init1(),this.init2(),this.init3()]).then(res=>{
        this.loadBtnConfigListQC();
      })

    },
    methods:{
      init1(){
        return this.$httpservice.get("api/Equipment/RawMaterials?equipmentId="+this.initvalue.id).then(res=>{
          this.allpowder = res.body.data
          this.oriAllPowderList = res.body.data
        })
      },
      init3(){
        return  this.$httpservice.get("api/Equipment/EquipmentChannels", {dtuNo:this.initvalue.dtuNumber}).then(res=>{
          this.powderData = res.body.data
          this.powderData.forEach(e=>{
            this.selectedpowder[e.sort-1] = e.rawMaterial
          })
        })
      },
      init2(){
        return this.$httpservice.get("api/Equipment/CupTypes", {pageIndex:0,pageSize:0,dtuNo:this.initvalue.dtuNumber}).then(res=>{
          this.allcuplist = res.body.data
          this.oriAllCupList = res.body.data
          this.isAllLoad = true
        })
      },
      // 初始化所有配方分组
      // init4(){
      //   return this.$httpservice.get("api/Beverage/CupTypeGroups",{equipmentTypeId:1}).then(res=>{
      //     this.cupTypeGroupList = res.body.data
      //   })
      // },
      //清空某个已选原料
      deletePowder(index){
        this.selectedpowder[index] = null
        this.$forceUpdate()
      },
      maxChange(val,maxNum){
        this.ruleForm.name9=Number(val)
        this.$nextTick(()=>{
          //比较输入的值和最大值，返回小的
          let num=Math.min(Number(val),maxNum)
          if(num<0){
            this.ruleForm.name9=0
          }else{
            this.ruleForm.name9=num
          }
        })
      },
      /**
       * 拉取数据
       */
      pullData(){
          let that = this;
          this.$httpservice.get("api/Equipment/ReadKeyConfigs",{equipmentId:that.initvalue.id}).then(
            function (data) {
              if(data.body.code=="200"){
                that.$message({
                  message: data.body.msg,
                  type: 'success'
                });
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'warning'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
            }
          );
      },
      /**
       * 刷新数据
       */
      refreshData(){
        this.selectedpowder = []
        this.BtnConfigList=[];
        this.drinks=[
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}],
          [{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100},{cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}]
         ],
          this.loadBtnConfigListQC();
      },
      changepowder(index){
        // 判断是否全部加载完成
        if(!this.isAllLoad){
          this.$message.error("请稍后，原料列表尚未加载完成...")
        }
        this.powderindex = index
        this.allvisible = true
        if(this.selectedpowder.length>0){
          this.powderid = this.selectedpowder[index].id
        }
      },
      changeallpowder(index){
        this.powderid = this.allpowder[index].id
      },
      selectpowder(){
        this.allvisible = false
        let find = this.allpowder.find(item=>{return item.id == this.powderid})
        this.selectedpowder[this.powderindex] = find
        for(var i=0;i<this.drinks.length;i++){
          for(var j=0;j<this.drinks[i].length;j++){
            this.drinks[this.powderindex][j] = {cupquantity:null,price:0.00,cup:null,cupAmountFineAdjustment:100}
          }
        }
      },
      selectdrink(index1,index2){
        this.cupAmountFineAdjustment1 = this.drinks[index1][index2].cupAmountFineAdjustment
        let t = this.drinks[index1][index2]
        if(!t.cup){
          this.cupid = -1
          this.cupquantity = 0
        }else{
          this.cupid = t.cup.id
          this.cupquantity = t.cupquantity
        }
        this.cupvisible = true

        console.log(this.allcuplist)
        console.log(this.selectedpowder)
        console.log(index1)
        this.cupindex1 = index1
        this.cupindex2 = index2
      },
      changecupe(index){
        this.cupid = this.allcuplist[index].id
      },
      changequantity(i){
        this.cupquantity= i
      },
      savepowder(){
        let cup = this.allcuplist.find(item=>{return item.id == this.cupid})

        this.drinks[this.cupindex1][this.cupindex2].cupquantity = this.cupquantity;
        this.drinks[this.cupindex1][this.cupindex2].cupAmountFineAdjustment = this.cupAmountFineAdjustment1;
        this.drinks[this.cupindex1][this.cupindex2].price = this.price;
        this.drinks[this.cupindex1][this.cupindex2].cup = cup;
        this.cupvisible = false
        this.drinks[this.cupindex1][this.cupindex2].cupAmountFineAdjustment = this.cupAmountFineAdjustment1
      },
      //获取按键信息
      loadBtnConfigListQC(){
        // this.menuConfigDialogVisible = true;
        let that = this;
        this.$httpservice.get("api/Equipment/KeyConfigs",{dtuNo:that.initvalue.dtuNumber}).then(
           (data) =>{
            if(data.body.code=="200"){
              that.BtnConfigList = data.body.data;
              let list =  that.BtnConfigList.filter(item=>{return item.cupType})
              if(list && list.length>0){
                for(let i in list){
                  if(list[i].price>0){
                    that.isFree = false;
                  }
                  let sort = list[i].sort-1
                  let index1 = sort%4
                  let index2 = Math.floor(sort/4)
                  //console.log(list[i])
                  that.selectedpowder[index2] = list[i].cupType.beverage.rawMaterials[0]

                  that.drinks[index2][index1].cupquantity = list[i].concentration;
                  that.drinks[index2][index1].cupAmountFineAdjustment = list[i].cupAmountFineAdjustment;
                  that.drinks[index2][index1].price = list[i].price;
                  that.drinks[index2][index1].cup = list[i].cupType;
                  that.$forceUpdate()

                }
              }
            }else{
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode')+statusCode,
              type: 'warning'
            });
          }
        );
      },
      deleteDrink(index1,index2){
        this.drinks[index1][index2]={
          cup:null,
          cupquantity:null,
          price:null
        }
        this.$forceUpdate();

      },
      //保存通道数据
      addChannel(){
        let postData = new Object();
        postData.dtuNo = this.initvalue.dtuNumber;
        postData.equipmentChannels = [];
        this.selectedpowder.forEach((e,index)=>{
          postData.equipmentChannels.push({sort:index+1,rawMaterial_ID:e.id})
        })
        this.$httpservice.post("api/Equipment/UploadEquipmentChannel", postData).then(res=>{
          if(res.body.data.code == "200"){
            that.$message({
              message: that.$t('equipmentmanagement.channelInformationSavedSuccessfully'),
              type: 'success'
            });
          }
        })
      },
      //按键设置
      addBtnConfig(flag){
        //编辑
        if(flag){
          if(this.Btnsort){
            let putData = new Object();

            putData.id = this.btnid;
            putData.equipment_ID = parseInt(this.initvalue.id);
            putData.sort = parseInt(this.Btnsort);
            putData.cupType_ID = this.cupTypeid;

                    let that = this;
                    this.$httpservice.put("api/Equipment/UpdateKeyConfig",putData).then(
                        function (data) {
                            if(data.body.code=="200"){
                                that.$message({
                                        message: that.$t('equipmentmanagement.modifyTheKeyConfigurationSuccessfully'),
                                        type: 'success'
                                });
                                that.loadBtnConfigListQC(that.initvalue.dtuNumber);
                                that.refreshData()
                            }else{
                                that.$message({
                                    message: data.body.msg,
                                    type: 'danger'
                                });
                            }
                        },
                        function (data) {
                            let statusCode = data.status;
                            that.$message({
                                message: that.$t('queryFailedStatusCode')+statusCode,
                                type: 'warning'
                            });
                        }
                    );
                }else{
                this.$message({
                        message: this.$t('equipmentmanagement.pleaseCompleteTheConfigurationInformation'),
                        type: 'warning'
                    });
                }
            }
            //新增
            else{
                if(this.postData !=null){
                    let that = this;

                    this.$httpservice.post("api/Equipment/AddKeyConfigs",that.postData).then(
                        function (data) {
                            if(data.body.code=="200"){
                                that.$message({
                                        message: that.$t('stc.newlyAddKeyConfigurationSuccessfully'),
                                        type: 'success'
                                });
                            }else{
                                that.$message({
                                    message: data.body.msg,
                                    type: 'danger'
                                });
                            }
                        },
                        function (data) {
                            let statusCode = data.status;
                            that.$message({
                                message: that.$t('queryFailedStatusCode')+statusCode,
                                type: 'warning'
                            });
                        }
                    );
                }else{
                  this.$message({
                        message: this.$t('equipmentmanagement.pleaseCompleteTheConfigurationInformation'),
                        type: 'warning'
                    });
                }
            }
        },
      //保存配置
      saveBtnConfig(){
        let that = this
        // 保存的时候要判断当前的饮料是否属于这个分组
        let powderFlag = 0
        let powderStr = ''
        // 判断原料和杯型是否属于这个组
        this.selectedpowder.forEach(item=>{
          if(item){
            if(this.allpowder.findIndex(i=>i.id == item.id)==-1){
              powderFlag++
              powderStr += item.name+","
            }else{
              console.log("符合的原料",item)
            }
          }
        })
        powderStr+="不属于当前组别【"+this.cupTypeGroup+'】'
        if(powderFlag>0){
          this.$message.error(powderStr)
          return false
        }
        // 判断杯型是否属于当前杯型
        this.postData.keyConfigPostDatas = []
        let arr = [];
        for(var i=0;i<this.drinks.length;i++){
          for(var j=0;j<this.drinks[i].length;j++){
            if(this.drinks[i][j].cup!=null){
              if(this.drinks[i][j].cup.beverage!=undefined){
                // 如果在集合里找不到这个杯型，就直接报错
                if(this.allcuplist.findIndex(item=>item.id==this.drinks[i][j].cup.id)==-1){
                  this.$message.error("【"+this.cupTypeGroup+"】中饮料"+this.drinks[i][j].cup.beverage.name+"没有"+this.drinks[i][j].cup.cupSize.name+"杯型")
                  return
                }
                let dbprice = this.drinks[i][j].price*1;
                let cupAmountFineAdjustment = this.drinks[i][j].cupAmountFineAdjustment
                if( this.drinks[i][j].cupAmountFineAdjustment == null){
                  cupAmountFineAdjustment = 100
                }
                let concentration = this.drinks[i][j].cupquantity
                arr.push({"sort":i*4 + j+1,"cupType_ID":this.drinks[i][j].cup.id,"name":this.drinks[i][j].cup.beverage.name,"price":dbprice,"concentration":concentration,"cupAmountFineAdjustment":parseInt(cupAmountFineAdjustment)});
              }
            }

          }
        }

        arr.forEach(e => {
          if(e.cupType_ID!= null){
            this.postData.keyConfigPostDatas.push({sort: e.sort,cupType_ID:e.cupType_ID,name:e.name,price:e.price,concentration:e.concentration,cupAmountFineAdjustment:e.cupAmountFineAdjustment});
          }
        })
        this.postData.equipment_ID = parseInt(this.initvalue.id);
        this.addChannel()
        this.addBtnConfig(false);
      },
      // 切换配方分组
      handleChangeCupTypeGroup(e){
        if(!this.isAllLoad){
          this.$message.error("请稍后，原料列表加载中...")
          this.cupTypeGroup = this.oldVal
          return
        }
        console.log('原生杯型',this.oriAllCupList)
        // 此时不做出改变，是在选择原料的时候，要增加查询的条件为只有这个分组下的饮品的原料
        // 计算当前分组下，拥有哪些原料
        let rawArr = [] // 临时原料
        let cupArr = [] // 临时杯型
        this.oriAllCupList.forEach(item=>{
          if(item.cupTypeGroup == this.cupTypeGroup){
            if(item.beverage){
              item.beverage.rawMaterials.forEach(item2=>{
                // 判断是否存在
                if(rawArr.findIndex(x => x.id == item2.id) == -1){
                  // 不存在就加入
                  rawArr.push(item2)
                }
              })
            }
            cupArr.push(item)

          }
        })
        this.allpowder = rawArr
        this.allcuplist = cupArr
      }
    },
    watch:{
      cupTypeGroup(val,oldVal){
        console.log(val,oldVal,'监听')
        this.oldVal = oldVal
      }
    }
  }
</script>
<style scoped>
  .back{
    padding: 20px;
    background: url("../../assets/images/equipment/background_pay.jpg");
    background-size: 100% 100%;
    text-align: center;
  }

  .body{
    display: inline-block;
    width: 60%;
  }
  .headback{
    background: url("../../assets/images/equipment/back_material.jpg");
    background-size: 100% 100%;
    overflow: hidden;
    padding: 10px 0px;
  }
  .c1{
    float: left;
    width: 25%;
    text-align: center;
  }
  .c2{
    float: left;
    width: 20%;
    text-align: center;
    position: relative;
    margin-bottom: 20px;
  }

  .c1 img,.c2 img{
    width: 100px;
  }
  .cname{
    display: inline-block;
    width: 110px;
    line-height: 25px;
    color: #2e2115;
    background: url("../../assets/images/equipment/tast_select_textview_back.png");
    background-size: 100% 100%;
    font-size: 12px;
  }
    .cnameyuan{
    display: inline-block;
    width: 70px;
    font-size: 12px;
    height: 25px!important;
  }
  .powderlist{
    overflow: hidden;
    max-height: 500px;
    overflow-y: auto;
  }
  .checked{
    position: absolute;
    left: 20px;
    top: 0px;
    width: 20px!important;
    height: 20px!important;
  }
  .checked2{
    position: absolute;
    right: -10px;
    top: 5px;
    width: 20px!important;
    height: 20px!important;
  }
  .bodyback{
    padding: 20px 0;
    background-color: #f7ebe1;
    overflow: hidden;
  }

  .drinkback{
    width: 100px;
    height: 100px;
    /* margin-bottom: 20px; */
    display: inline-block;
    cursor: pointer;
  }
  .noneback{
    background: url("../../assets/images/equipment/add.png");
    background-size: 100% 100%;
  }
  .q1back{
    background: url("../../assets/images/equipment/background_normal.png");
    background-size: 100% 100%;
  }
  .q2back{
    background: url("../../assets/images/equipment/background_bold.png");
    background-size: 100% 100%;
  }
  .q3back{
    background: url("../../assets/images/equipment/background_more_bold.png");
    background-size: 100% 100%;
  }
  .quantity{
    display: inline-block;
    line-height: 30px;
    vertical-align: top;
    margin-right: 20px;
    width: 60px;
    text-align: center;
    background-size: 100% 100% !important;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .q1{
    background: url("../../assets/images/equipment/background_normal.png");
  }
  .q2{
    background: url("../../assets/images/equipment/background_bold.png");
  }
  .q3{
    background: url("../../assets/images/equipment/background_more_bold.png");
  }
  .dinkpic{
    display: inline-block;
    width: 80px!important;
    height: 80px!important;
    display: inline-block;
    margin-top: 10px;
  }

  .nopic{
    display: inline-block;
    width: 70px!important;
    height: 70px!important;
    display: inline-block;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/equipmentButtonConfig.vue